export default __webpack_public_path__ + "static/media/element_38.9cec5553.webp";